// extracted by mini-css-extract-plugin
export default {"authContainer":"style_authContainer__wa+dx","authCard":"style_authCard__+p3fF","authLogo":"style_authLogo__QDdGT"};